module.exports = __webpack_public_path__ + "img/no-quest.33f1d434.svg";